import PropTypes from 'prop-types';
import React from 'react';
import { ListItem } from './ListItem';

export class ModalListPanel extends React.Component {
  render() {
    const { items, selectedIndex, handleListItemClick, handleListItemFocus, qaTag } = this.props;

    return (
      <div data-qa-container={qaTag}>
        <ul className="list-group custom-list marginlr20">
          {
            items.map((item, index) => (
              <ListItem
                key={index}
                index={ index }
                ref={ 'listItem_' + index }
                handleClick={ handleListItemClick }
                handleOnFocus={handleListItemFocus}
                className={ item.itemId === selectedIndex ? 'active' : null }
                showItemArrow={false}
                { ...item }
              />
            ))
          }
        </ul>
      </div>
    );
  }
}

ModalListPanel.propTypes = {
  items: PropTypes.array,
  selectedIndex: PropTypes.any,
  handleListItemClick: PropTypes.func,
  handleListItemFocus: PropTypes.func,
  qaTag: PropTypes.string,
};
